import { Text, type TextProps } from '@components/atoms/typography';
import { DEFAULT_LOCALE, formatPercentage } from '@utils';
import * as React from 'react';

interface PercentageProps extends TextProps {
	percentage?: number;
	locale?: string;
	parse?: (percentage: string) => string;
	negative?: boolean;
}

export const Percentage = ({
	percentage = NaN,
	locale = DEFAULT_LOCALE,
	negative,
	parse,
	asChild,
	...props
}: PercentageProps) => {
	const formattedPercentage = React.useMemo(() => {
		return formatPercentage(percentage, { locale, negative });
	}, [percentage, locale, negative]);

	const parsedPercentage = parse ? parse(formattedPercentage) : formattedPercentage;

	if (asChild) {
		return <span>{parsedPercentage}</span>;
	}

	return (
		<Text {...props} as="span" className={props.className} color={props.color}>
			{parsedPercentage}
		</Text>
	);
};
